import {
  InspectionComponentName,
  SensorType,
} from '@energybox/react-ui-library/dist/types';
import { accent } from '@energybox/react-ui-library/dist/utils';
import {
  Svg,
  G,
  Path,
  Circle,
  Rect,
  Defs,
  ClipPath,
} from '@react-pdf/renderer';

type IconProps = {
  size: string | number;
  color?: string;
};

const TemperatureIcon = ({ size, color }: IconProps) => (
  <Svg viewBox="0 0 16 16" width={size} height={size}>
    <G fill={color || accent.main}>
      <Path
        d="M9.3 4.8l-3.8 6.6c-.3 0-.7.2-.9.5-.2.5-.1 1.1.4 1.4.2.1.3.1.5.1.3 0 .7-.2.9-.5.2-.3.2-.7 0-1l3.8-6.6-.9-.5z"
        fill="currentColor"
      />
      <Path
        d="M11.3 1c.3 0 .5.1.7.2.3.2.6.5.7.9s.1.8-.1 1.1L8 11.1l-.2.4.1.4c.2.6.1 1.3-.3 1.9-.4.7-1.2 1.2-2.1 1.2-.4 0-.9-.1-1.2-.3-.6-.3-1-.9-1.2-1.5-.2-.6-.1-1.3.2-1.9.3-.6.9-1 1.5-1.2l.4-.1.2-.4L10 1.8c.2-.5.7-.8 1.3-.8m0-1c-.9 0-1.7.4-2.2 1.3L4.6 9.1c-.8.2-1.6.8-2.1 1.6-1 1.7-.4 3.8 1.3 4.8.5.3 1.1.5 1.7.5 1.2 0 2.4-.6 3-1.8.5-.8.6-1.8.4-2.6l4.5-7.8c.7-1.2.3-2.7-.9-3.4-.4-.3-.8-.4-1.2-.4zM5.4 2.6l-.5.9.9.5.5-.9-.9-.5zM6.4.9l-.5.8.9.5.5-.8-.9-.5zM4.4 4.3l-.5.9.9.5.5-.9-.9-.5zM2.6 5.6l-.5.8 1.7 1 .5-.8-1.7-1z"
        fill="currentColor"
      />
      <G>
        <Path
          d="M11 14.6h-.2c-.3-.1-.4-.4-.3-.6.1-.2.1-.5.1-.8 0-.3 0-.5-.1-.8-.1-.3 0-.5.3-.6.3-.1.5 0 .6.3.1.4.2.7.2 1.1 0 .4-.1.8-.2 1.1 0 .2-.2.3-.4.3z"
          fill="currentColor"
        />
      </G>
      <G>
        <Path
          d="M13.1 15.3h-.2c-.3-.1-.4-.4-.3-.6.2-.5.3-1 .3-1.5s-.1-1-.3-1.5c-.1-.3 0-.5.3-.6.3-.1.5 0 .6.3.2.6.3 1.2.3 1.8 0 .6-.1 1.2-.3 1.8 0 .2-.2.3-.4.3z"
          fill="currentColor"
        />
      </G>
    </G>
  </Svg>
);

const HumidityIcon = ({ size, color }: IconProps) => (
  <Svg viewBox="0 0 16 16" width={size} height={size}>
    <G fill={color || accent.main}>
      <Path
        d="M6.1 6.5c-.5 0-1-.2-1.4-.6-.4-.4-1-.4-1.3 0-.7.7-2 .7-2.7 0-.2-.2-.2-.5 0-.7.1-.2.5-.2.7 0 .4.4 1 .4 1.3 0 .8-.8 2-.8 2.7 0 .4.4 1 .4 1.3 0 .3-.2.6-.2.8 0s.2.5 0 .7c-.4.4-.9.6-1.4.6zM2 9.3c-.5 0-1-.2-1.4-.6-.2-.2-.2-.5 0-.7s.5-.2.7 0c.4.4 1 .4 1.3 0 .7-.7 2-.7 2.7 0 .3.3.7.4 1 .2.3-.1.5 0 .7.3.1.3 0 .5-.3.7-.6.3-1.4.1-2-.4-.4-.4-1-.4-1.3 0-.4.4-.9.5-1.4.5zM6 12.3c-.5 0-1-.2-1.4-.6-.4-.4-1-.4-1.3 0-.7.7-2 .7-2.7 0-.2-.2-.2-.5 0-.7s.5-.2.7 0c.4.4 1 .4 1.3 0 .7-.7 2-.7 2.7 0 .2.2.4.3.7.3.3 0 .5.2.5.5s-.2.5-.5.5zM11.5 3.4C13 7.6 14 10.7 14 11.6c0 1.3-1.1 2.4-2.5 2.4S9 12.9 9 11.6c0-.9 1-4 2.5-8.2m0-2.4c-.1 0-.2.1-.2.2C10.5 3.3 8 10 8 11.6c0 1.9 1.6 3.4 3.5 3.4s3.5-1.5 3.5-3.4c0-1.6-2.5-8.3-3.3-10.4 0-.1-.1-.2-.2-.2z"
        fill="currentColor"
      />
    </G>
  </Svg>
);

const DoorIcon = ({ size, color }: IconProps) => (
  <Svg viewBox="0 0 16 16" width={size} height={size}>
    <G fill={color || accent.main}>
      <Path
        d="M15.5 13h-2c-.3 0-.5.2-.5.5s.2.5.5.5h2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM2.5 14h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5s-.2.5-.5.5z"
        fill="currentColor"
      />
      <Path d="M13 3v10h-2V3h2m1-1h-4v12h4V2z" fill="currentColor" />
      <Path
        d="M10 1.2v13.5l-7-1.6V2.8l7-1.6M11 0L2 2v12l9 2V0z"
        fill="currentColor"
      />
      <Path
        d="M5.4 10c-.2 0-.4-.1-.5-.3-.2-.6-.3-1.1-.3-1.7 0-.6.1-1.1.3-1.7.1-.2.4-.4.7-.3.2.1.4.4.3.7-.2.4-.3.9-.3 1.3s.1.9.3 1.3c.1.3-.1.6-.3.7h-.2z"
        fill="currentColor"
      />
      <Circle cx="8" cy="8" r="1" fill="currentColor" />
    </G>
  </Svg>
);

export const SensorTypeIcon = (type: SensorType) => {
  switch (type) {
    case SensorType.TEMPERATURE:
      return <TemperatureIcon size={10} />;
    case SensorType.HUMIDITY:
      return <HumidityIcon size={10} />;
    case SensorType.BINARY:
      return <DoorIcon size={10} />;
  }
};

const EdgeController = ({ size, color }: IconProps) => (
  <Svg viewBox="0 0 18 18" width={size} height={size}>
    <G fill={color}>
      <Path
        fill="currentColor"
        d="M13.31,3.49a.63.63,0,0,0,.19,0,3.67,3.67,0,0,1,2.8,0,.54.54,0,0,0,.69-.3.53.53,0,0,0-.3-.69,4.82,4.82,0,0,0-3.58,0,.53.53,0,0,0-.3.69A.54.54,0,0,0,13.31,3.49Z"
      />
      <Circle fill="currentColor" cx="14.9" cy="4.56" r="0.53" />
      <Path
        fill="currentColor"
        d="M1.62,3.49l.2,0a3.65,3.65,0,0,1,2.79,0,.53.53,0,0,0,.69-.3A.53.53,0,0,0,5,2.47a4.82,4.82,0,0,0-3.58,0,.53.53,0,0,0-.29.69A.52.52,0,0,0,1.62,3.49Z"
      />
      <Circle fill="currentColor" cx="3.21" cy="4.56" r="0.53" />
      <Path
        fill="currentColor"
        d="M15.43,9.34V6.68a.53.53,0,0,0-1.06,0V9.34H3.74V6.68a.53.53,0,0,0-.53-.53.53.53,0,0,0-.53.53V9.34A2.12,2.12,0,0,0,.56,11.46v2.13a2.12,2.12,0,0,0,2.12,2.12H15.43a2.13,2.13,0,0,0,2.13-2.12V11.46A2.13,2.13,0,0,0,15.43,9.34Zm1.06,4.25a1.06,1.06,0,0,1-1.06,1.06H2.68a1.07,1.07,0,0,1-1.06-1.06V11.46A1.07,1.07,0,0,1,2.68,10.4H15.43a1.06,1.06,0,0,1,1.06,1.06Z"
      />
      <Path
        fill="currentColor"
        d="M6.4,12.53H3.21a.53.53,0,0,0-.53.53.53.53,0,0,0,.53.53H6.4a.53.53,0,0,0,.53-.53A.53.53,0,0,0,6.4,12.53Z"
      />
      <Circle fill="currentColor" cx="14.9" cy="13.06" r="0.53" />
    </G>
  </Svg>
);

const SiteController = ({ size, color }: IconProps) => (
  <Svg viewBox="0 0 18 18" width={size} height={size}>
    <G fill={color}>
      <Path
        fill="currentColor"
        d="M17.52,6.26h0c-.25-.83-1.91-.62-2.95-.39-.13-.18-.28-.35-.43-.53A19.71,19.71,0,0,0,15,3.26c.38-1.16.36-1.82-.06-2a1.91,1.91,0,0,0-1.71.29.52.52,0,0,0-.33-.11.59.59,0,0,0-.59.59.41.41,0,0,0,0,.1A20.16,20.16,0,0,0,10.7,3.45,6.16,6.16,0,0,0,9,3.38a3.92,3.92,0,0,0-1.47-1,.85.85,0,0,0-.77.18,2.41,2.41,0,0,0-.48,1.75A6.18,6.18,0,0,0,3.48,8.62C2.25,9.13.83,10.11.6,10.81a1,1,0,0,0,.25,1c.43.48,1.3.64,2.76.48a7.86,7.86,0,0,0-1.06,3,.88.88,0,0,0,.24.65,1.05,1.05,0,0,0,.71.26,6.22,6.22,0,0,0,2.94-1.45,6.06,6.06,0,0,0,3.15.86,6.37,6.37,0,0,0,1.27-.12,2.25,2.25,0,0,0,1.47.81,1.11,1.11,0,0,0,.34-.06,1.23,1.23,0,0,0,.73-.63,2.31,2.31,0,0,0,.22-.84,2,2,0,0,0,1.5-1.92A1.84,1.84,0,0,0,15,12.4a6,6,0,0,0,.73-2.87,5.89,5.89,0,0,0-.11-1.22,4.87,4.87,0,0,0,1.79-1.46A.8.8,0,0,0,17.52,6.26Zm-14.11,3c0,.1,0,.19,0,.28a6,6,0,0,0,.42,2.21C2,12,1.45,11.67,1.25,11.47h0A.47.47,0,0,1,1.13,11,5.44,5.44,0,0,1,3.41,9.25ZM7.12,3a.1.1,0,0,1,.09,0l.13,0a2.35,2.35,0,0,1,.89.52A6.76,6.76,0,0,0,6.8,4a1.55,1.55,0,0,1,.31-1Zm5.78-.4A.6.6,0,0,0,13.49,2c.54-.29,1-.39,1.2-.28s-.14,1.43-1,3.19a6.28,6.28,0,0,0-2.36-1.33c.45-.39.89-.75,1.31-1A.6.6,0,0,0,12.9,2.59Zm-3,1.62-.09.09a1.37,1.37,0,0,0-.16-.18H10Zm2.63,5a17.53,17.53,0,0,0-2.37-4.44l.54-.52a5.42,5.42,0,0,1,4.13,3.91C14.19,8.46,13.41,8.81,12.51,9.18Zm.61,1.74h-.06c-.11-.4-.24-.81-.37-1.22.81-.32,1.56-.66,2.25-1a5.4,5.4,0,0,1,.06.83,5.23,5.23,0,0,1-.43,2.05A1.84,1.84,0,0,0,13.12,10.92Zm-7.4-1.3a.45.45,0,0,1-.14-.11.64.64,0,0,1-.15-.38A.57.57,0,0,1,6,8.55a.33.33,0,0,1,.17,0l.07,0s.08,0,.14.09a.57.57,0,0,1,.19.42A.55.55,0,0,1,5.72,9.62Zm-.12.5a1.1,1.1,0,0,0,.4.08A1.07,1.07,0,0,0,7.07,9.13a1.08,1.08,0,0,0-.25-.69,30.26,30.26,0,0,1,2-2.4l.87-.9A17,17,0,0,1,12,9.38c-1.33.51-2.81,1-4.41,1.5-1.22.35-2.16.59-2.93.73C4.93,11.13,5.26,10.62,5.6,10.12ZM8.44,5.65C7.72,6.43,7,7.27,6.36,8.12A1.15,1.15,0,0,0,6,8.05,1.08,1.08,0,0,0,4.93,9.13a1,1,0,0,0,.22.65c-.27.4-.53.8-.77,1.19a5.28,5.28,0,0,1-.21-1.44A5.41,5.41,0,0,1,8.92,4.15l0,0,.44.51C9.08,5,8.78,5.31,8.44,5.65Zm-.7,5.75c1.61-.48,3.09-1,4.42-1.48.14.4.25.77.35,1.11a2,2,0,0,0-.72,3.42,5.34,5.34,0,0,1-6.93-2.31C5.74,12,6.71,11.72,7.74,11.4Zm5.15.32.19,0h.05a1.21,1.21,0,0,1,1.1.72,1.26,1.26,0,0,1,.11.53V13a1.16,1.16,0,0,1-.92,1.14l-.18,0a1,1,0,0,1-.64-.06,1.31,1.31,0,0,1-.78-1.17A1.27,1.27,0,0,1,12.89,11.72Zm-8.73.75a6.35,6.35,0,0,0,1.78,2c-1.11.84-2.37,1.47-2.76,1.1h0s-.06-.21-.06-.26A7.17,7.17,0,0,1,4.16,12.47Zm8.89,2.46a1.8,1.8,0,0,1-.14.49.74.74,0,0,1-.42.38,1.23,1.23,0,0,1-1-.4,6.41,6.41,0,0,0,1.14-.53A1.54,1.54,0,0,0,13.05,14.93Zm2.46-7.18a5.93,5.93,0,0,0-.61-1.37c1.35-.26,2-.14,2.08,0,0,0,0,.08,0,.14v0A3.82,3.82,0,0,1,15.51,7.75Z"
      />
    </G>
  </Svg>
);

const EnergyPro = ({ size, color }: IconProps) => (
  <Svg viewBox="0 0 18 18" width={size} height={size}>
    <G fill={color}>
      <Path
        fill="currentColor"
        style={{ fillRule: 'evenodd' }}
        d="M4.58,6.78h9.23a.3.3,0,0,0,.27-.32V4.7a.31.31,0,0,0-.27-.33H4.58a.3.3,0,0,0-.26.33V6.46A.29.29,0,0,0,4.58,6.78Zm-.34.64h9.91a.58.58,0,0,0,.57-.57V4.31a.57.57,0,0,0-.57-.57H4.24a.57.57,0,0,0-.57.57V6.85A.58.58,0,0,0,4.24,7.42ZM11,11.1h3.75v-.92H11Zm0,1.84h3.75V12H11Z"
      />
      <Path
        fill="none"
        d="M16.44,2.08H2a.22.22,0,0,0-.22.21V16.71a.21.21,0,0,0,.22.21H4.22V15.67h.83v1.25H6.71V15.67h.83v1.25H9.2V15.67H10v1.25h6.41a.21.21,0,0,0,.22-.21V2.29A.22.22,0,0,0,16.44,2.08Z"
      />
      <Path
        fill="currentColor"
        d="M17.27.34H4.79v1a.13.13,0,0,1-.14.13H1.92a.13.13,0,0,1-.13-.13V.34H1.12A.21.21,0,0,0,.9.55v17a.22.22,0,0,0,.22.21H17.27a.22.22,0,0,0,.22-.21V.55A.21.21,0,0,0,17.27.34Zm-.61,16.37a.21.21,0,0,1-.22.21H10V15.67H9.2v1.25H7.54V15.67H6.71v1.25H5.05V15.67H4.22v1.25H2a.21.21,0,0,1-.22-.21V2.29A.22.22,0,0,1,2,2.08H16.44a.22.22,0,0,1,.22.21Z"
      />
      <Rect
        fill="currentColor"
        x="2.25"
        y="0.34"
        width="2.07"
        height="0.68"
        rx="0.15"
      />
    </G>
  </Svg>
);

const EnergyPro2 = ({ size, color }: IconProps) => (
  <Svg width={size} viewBox="0 0 40 19">
    <G>
      <Path
        d="M17.6367 9.81989H25.9913V5.39185H17.6367V9.81989ZM18.5106 6.29369H25.1174V8.91805H18.5106V6.29369Z"
        fill="#333E48"
      />
      <Path
        d="M27.8496 9.81989H36.2042V5.39185H27.8496V9.81989ZM28.7235 6.29369H35.3303V8.91805H28.7235V6.29369Z"
        fill="#333E48"
      />
      <Path
        d="M3.71345 6.49902H2.78516V14.2481H3.71345V6.49902Z"
        fill="#333E48"
      />
      <Path
        d="M5.56891 6.49902H4.64062V14.2481H5.56891V6.49902Z"
        fill="#333E48"
      />
      <Path
        d="M7.42634 6.49902H6.49805V14.2481H7.42634V6.49902Z"
        fill="#333E48"
      />
      <Path
        d="M9.28376 6.49902H8.35547V14.2481H9.28376V6.49902Z"
        fill="#333E48"
      />
      <Path
        d="M11.1392 6.49902H10.2109V14.2481H11.1392V6.49902Z"
        fill="#333E48"
      />
      <Path
        d="M12.9966 6.49902H12.0684V14.2481H12.9966V6.49902Z"
        fill="#333E48"
      />
      <Path
        d="M14.8521 6.49902H13.9238V14.2481H14.8521V6.49902Z"
        fill="#333E48"
      />
      <Path
        d="M34.0311 0.963867H5.9689C2.68276 0.963867 0 4.16313 0 8.09302V18.9749H40V8.09302C40 4.16313 37.3172 0.963867 34.0311 0.963867ZM18.9371 17.5026V13.6724H21.657V17.5026H18.9371ZM25.9178 17.5026V13.6724H28.6377V17.5026H25.9178ZM32.8893 17.5026V13.6724H35.6092V17.5026H32.8893ZM39.0717 17.8569H36.5375V12.5653H31.961V17.8569H29.566V12.5653H24.9896V17.8569H22.5946V12.5653H18.0181V17.8569H0.92829V8.09302C0.92829 4.77199 3.19332 2.07088 5.9689 2.07088H34.0311C36.816 2.07088 39.0717 4.77199 39.0717 8.09302V17.8679V17.8569Z"
        fill="#333E48"
      />
    </G>
  </Svg>
);

const Thermostat = ({ size, color }: IconProps) => (
  <Svg viewBox="0 0 18 18" width={size} height={size}>
    <G fill={color}>
      <Path
        fill="currentColor"
        d="M10.4,11.77l.91,1.1H9.49l.91-1.1m0-.46L8.84,13.2H12L10.4,11.31Z"
      />
      <Path
        fill="currentColor"
        d="M13.18,12.75l-.92-1.11h1.83l-.91,1.11m0,.45,1.56-1.89H11.62l1.56,1.89Z"
      />
      <Path
        fill="currentColor"
        d="M7,11.62a.64.64,0,0,1,.64.64A.64.64,0,0,1,7,12.9a.64.64,0,1,1,0-1.28m0-.31A.95.95,0,1,0,7,13.2a.95.95,0,0,0,0-1.89Z"
      />
      <Path
        fill="currentColor"
        d="M4.54,11.62a.64.64,0,0,1,.64.64.64.64,0,0,1-1.28,0,.64.64,0,0,1,.64-.64m0-.31a.95.95,0,1,0,0,1.89.95.95,0,0,0,0-1.89Z"
      />
      <Path
        fill="currentColor"
        d="M14.11,4.48V9.92H4.67V4.48h9.44M14.74,4H4v6.38h10.7V4Z"
      />
      <Path
        fill="currentColor"
        d="M16.38,2.83a.49.49,0,0,1,.49.49V13.9a.49.49,0,0,1-.49.49H2a.49.49,0,0,1-.49-.49V3.32A.49.49,0,0,1,2,2.83H16.38m.17-.65H1.87a1,1,0,0,0-1,1V14a1,1,0,0,0,1,1H16.55a1,1,0,0,0,1-1V3.2a1,1,0,0,0-1-1Z"
      />
      <Path
        fill="currentColor"
        d="M5.52,6.52a.66.66,0,0,1,.33-.58.64.64,0,0,1,.34-.09.66.66,0,0,1,.57.33.69.69,0,0,1,.09.34.63.63,0,0,1-.09.33.69.69,0,0,1-.24.24.66.66,0,0,1-.33.09A.69.69,0,0,1,5.71,7,.64.64,0,0,1,5.52,6.52Zm.37,0A.32.32,0,0,0,6,6.73a.33.33,0,0,0,.22.08.29.29,0,0,0,.21-.09.27.27,0,0,0,.09-.2A.29.29,0,0,0,6.4,6.3a.29.29,0,0,0-.21-.09A.29.29,0,0,0,6,6.3.33.33,0,0,0,5.89,6.52Z"
      />
      <Path
        fill="currentColor"
        d="M8.58,6.35a.6.6,0,0,0-.52.25,1.19,1.19,0,0,0-.19.7c0,.63.24,1,.71,1A2.2,2.2,0,0,0,9.3,8.1v.5a2.13,2.13,0,0,1-.78.14,1.19,1.19,0,0,1-.94-.37A1.61,1.61,0,0,1,7.26,7.3a1.71,1.71,0,0,1,.16-.77A1.12,1.12,0,0,1,7.88,6a1.33,1.33,0,0,1,.7-.18,1.9,1.9,0,0,1,.82.2l-.19.48L8.89,6.4A1.12,1.12,0,0,0,8.58,6.35Z"
      />
      <Path fill="currentColor" d="M11.15,5.89,10.1,8.7H9.57l1-2.81Z" />
      <Path
        fill="currentColor"
        d="M12.11,8.7h-.58V5.89h1.61v.49h-1V7.1h1v.49h-1Z"
      />
    </G>
  </Svg>
);

const Hub = ({ size, color }: IconProps) => (
  <Svg viewBox="0 0 18 18" width={size} height={size}>
    <G fill={color}>
      <Path
        fill="currentColor"
        d="M17.14,1.55a5.15,5.15,0,0,0-3.82,0,.57.57,0,0,0,.21,1.09.49.49,0,0,0,.21,0,4,4,0,0,1,3,0,.57.57,0,1,0,.42-1Z"
      />
      <Circle fill="currentColor" cx="15.23" cy="3.78" r="0.57" />
      <Path
        fill="currentColor"
        d="M15.14,5.48a.56.56,0,0,0-.57.56v4.2a5.71,5.71,0,0,0-4-4.53l-.08,0-.32-.08A5.49,5.49,0,0,0,9,5.48a5.34,5.34,0,0,0-1.21.13l-.33.08-.09,0a5.69,5.69,0,0,0-4,4.89V6a.56.56,0,0,0-.57-.56A.55.55,0,0,0,2.21,6v6.8a.56.56,0,0,0,.56.57.57.57,0,0,0,.57-.57V11.73a2.7,2.7,0,0,0,0,.28A5.56,5.56,0,0,0,5.1,15.28a1.64,1.64,0,0,0,.24.21l.07.06a5.65,5.65,0,0,0,7.14,0l.07-.06a1.71,1.71,0,0,0,.25-.22,5.58,5.58,0,0,0,1.7-3.18V12h0a1.24,1.24,0,0,0,0-.27V12h0a.19.19,0,0,1,0,.08v.75a.57.57,0,0,0,.57.57.56.56,0,0,0,.56-.57V6A.55.55,0,0,0,15.14,5.48Zm-11,5.67a4.86,4.86,0,0,1,3.3-4.58,5.65,5.65,0,0,1-3.28,4.81A.9.9,0,0,1,4.15,11.15ZM6.07,15a5.59,5.59,0,0,1,5.83,0A4.91,4.91,0,0,1,6.07,15Zm6.43-1a6.85,6.85,0,0,0-7,0,4.42,4.42,0,0,1-.85-1.6,6.84,6.84,0,0,0,4-5.79l.39,0,.39,0a6.85,6.85,0,0,0,4,5.79A4.7,4.7,0,0,1,12.5,14Zm1.3-2.64a5.67,5.67,0,0,1-3.3-4.81,4.85,4.85,0,0,1,3.31,4.58A1.77,1.77,0,0,1,13.8,11.38Z"
      />
      <Path
        fill="currentColor"
        d="M4.26,2.6a.49.49,0,0,0,.21,0,.57.57,0,0,0,.21-1.09,5.15,5.15,0,0,0-3.82,0A.57.57,0,1,0,1.28,2.6,4,4,0,0,1,4.26,2.6Z"
      />
      <Circle fill="currentColor" cx="2.77" cy="3.78" r="0.57" />
    </G>
  </Svg>
);

export const DeviceIcon = ({ type }: { type: InspectionComponentName }) => {
  switch (type) {
    case InspectionComponentName.EDGE_CONTROLLER:
      return <EdgeController size={20} />;
    case InspectionComponentName.SITE_CONTROLLER:
      return <SiteController size={20} />;
    case InspectionComponentName.ENERGY_PRO:
      return <EnergyPro size={20} />;
    case InspectionComponentName.ENERGY_PRO2:
      return <EnergyPro2 size={20} />;
    case InspectionComponentName.THERMOSTAT:
    case InspectionComponentName.SENSORS_NEARBY:
      return <Thermostat size={20} />;
    case InspectionComponentName.HUB:
      return <Hub size={20} />;
    default:
      return <></>;
  }
};
